// extracted by mini-css-extract-plugin
module.exports = {"body":"ContentBlock_body__2jU8P"};